import {
  StyleRulesCallback,
  WithStyles,
  withStyles as withStylesCb
} from "@material-ui/core/styles";

import { LOGO_HEIGHT, LOGO_WIDTH, LOGO_WIDTH_MOBILE, LOGO_HEIGHT_MOBILE } from "./constants";

export const styles: StyleRulesCallback = ({ breakpoints }) => ({
  logo: {
    height: LOGO_HEIGHT_MOBILE,
    width: LOGO_WIDTH_MOBILE,
    [breakpoints.up("sm")]: {
      height: LOGO_HEIGHT,
      width: LOGO_WIDTH
    }
  }
});

export type Styles = WithStyles<typeof styles>;
export const withStyles = withStylesCb(styles);
